import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="header-wrapper">
      <div className="top-bar">
        <div className="top-bar-right">
          <span>📞 (224) 226-0693</span>
          <span>✉️ readymoverschicago@gmail.com</span>
          <span>⏰ 8AM-8PM</span>
        </div>
      </div>
      <header>
        <div className="header-left">
          <img src={logo} alt="Ready Movers Logo" className="header-logo" />
          <h1 className="header-title">Ready Movers</h1>
        </div>
        <button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          ☰
        </button>
        <nav className={isOpen ? "nav-open" : ""}>
          <Link to="/" onClick={() => setIsOpen(false)}>
            Home
          </Link>
          <Link to="/move-form" onClick={() => setIsOpen(false)}>
            Quote Form
          </Link>
          <Link to="/services" onClick={() => setIsOpen(false)}>
            Services
          </Link>
          <Link to="/reviews" onClick={() => setIsOpen(false)}>
            Reviews
          </Link>
          <Link to="/why-us" onClick={() => setIsOpen(false)}>
            Why Us
          </Link>
          <Link to="/about" onClick={() => setIsOpen(false)}>
            About
          </Link>
          <Link to="/contact" onClick={() => setIsOpen(false)}>
            Contact
          </Link>
        </nav>
      </header>
    </div>
  );
}

export default Header;
